import { Component } from '@angular/core';
import { NavController, NavParams, IonicPage } from 'ionic-angular';
@IonicPage()
@Component({
  selector: 'page-image-modal',
  templateUrl: 'image-modal.html'
})
export class ImageModalPage {

  private image;
  constructor(public navCtrl: NavController, public navParams: NavParams) { }

  ionViewDidLoad() {
    this.image = this.navParams.get('img');
  }

  close() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/image-modal/image-modal.ts